import { render } from "./BanglaGuideline.vue?vue&type=template&id=12be8f11&scoped=true"
import script from "./BanglaGuideline.vue?vue&type=script&lang=js"
export * from "./BanglaGuideline.vue?vue&type=script&lang=js"

import "./BanglaGuideline.vue?vue&type=style&index=0&id=12be8f11&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12be8f11"]])

export default __exports__